import { Route } from '@angular/router';
import { LayoutComponent } from '@layout/layout.component';
import { AlreadyLoginGuard } from '@shared/guard/alreadyLogin.guard';
import { Page404Component } from '@shared-ui/page404/page404.component';
export const appRoutes: Route[] = [
  {
    path: '',
    canActivate: [AlreadyLoginGuard],
    component: LayoutComponent,
    data: {
      layout: 'empty'
    },
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'sign-in' },
      {
        path: 'account-deletion',
        loadComponent: () =>
          import('./modules/account-deletion/account-deletion.component').then(
            (m: any) => m.AccountDeletionComponent
          )
      },
      {
        path: 'sign-in',
        loadComponent: () =>
          import('./modules/sign-in/sign-in.component').then((m: any) => m.AuthSignInComponent)
      },
      {
        path: 'sign-up',
        loadComponent: () =>
          import('./modules/sign-up/sign-up.component').then((m: any) => m.AuthSignUpComponent)
      },
      {
        path: 'forgot-password',
        loadComponent: () =>
          import('./modules/forgot-password/forgot-password.component').then(
            (m: any) => m.AuthForgotPasswordComponent
          )
      },
      {
        path: 'email-verify',
        loadComponent: () =>
          import('./modules/user-validation/email-validation/email-validation.component').then(
            (m: any) => m.EmailValidatorComponent
          )
      },
      {
        path: 'number-verify',
        loadComponent: () =>
          import('./modules/user-validation/number-validation/number-validation.component').then(
            (m: any) => m.NumberValidatorComponent
          )
      }
    ]
  },

  {
    path: '**',
    component: Page404Component
  }
];
